// extracted by mini-css-extract-plugin
module.exports = {"displayToggle":"TeamsGroupingToggle_displayToggle__UETjE","hidden":"TeamsGroupingToggle_hidden__dPFTE","activeTab":"TeamsGroupingToggle_activeTab__VHouE"};